const initialize = () => {
    const apiAccessDeleteModal = document.getElementById('apiAccessDeleteModal');
    if (!apiAccessDeleteModal) {
        return;
    }
    apiAccessDeleteModal.addEventListener('show.bs.modal', (event) => {
        const { accesstoken: accessToken, action } = event.relatedTarget.dataset;

        apiAccessDeleteModal.querySelector('#apiAccessDelete').setAttribute('action', action);
        apiAccessDeleteModal.querySelector('#accessToken').value = accessToken;
    });
};

export default initialize;
